<div
  class="container m-b-20"
  fxLayout="row"
  fxLayoutAlign="end"
  fxLayoutGap="20px"
>
  <button
    *ngIf="hasRefundAccess()"
    mat-raised-button
    color="primary"
    (click)="openReturnDialog()"
    matomoClick="Refund Transaction"
    category="Transaction Management"
    name="Refund Button"
  >
    {{ "TRANSACTION_DETAILS.REFUND" | translate }}
  </button>

  <button
    mat-raised-button
    color="primary"
    (click)="openBPMNDialog()"
    matomoClick="View BPMN"
    category="Transaction Management"
    name="BPMN Diagram Button"
  >
    {{ "TRANSACTION_DETAILS.BPMN_DIAGRAM" | translate }}
  </button>
</div>

<div class="container">
  <mat-grid-list cols="2" rowHeight="350">
    <mat-grid-tile [colspan]="1" [rowspan]="1">
      <mat-card class="mat-elevation-z8" *ngIf="datasource.transfer">
        <mat-card-title>{{
          "TRANSACTION_DETAILS.PAYER" | translate
        }}</mat-card-title>
        <mat-card-content>
          <div fxLayout="row wrap" class="content">
            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              class="header"
              *ngIf="datasource.transfer.payerPartyIdType !== undefined"
            >
              {{ "TRANSACTION_DETAILS.ID_TYPE" | translate }}
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              *ngIf="datasource.transfer.payerPartyIdType !== undefined"
            >
              {{ datasource.transfer.payerPartyIdType }}
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              class="header"
              *ngIf="datasource.transfer.payerPartyId !== undefined"
            >
              {{ "TRANSACTION_DETAILS.ID" | translate }}
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              *ngIf="datasource.transfer.payerPartyId !== undefined"
            >
              {{ datasource.transfer.payerPartyId }}
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              class="header"
              *ngIf="datasource.transfer.payerDfspId !== undefined"
            >
              {{ "TRANSACTION_DETAILS.DFSP_ID" | translate }}
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              *ngIf="datasource.transfer.payerDfspId !== undefined"
            >
              {{ datasource.transfer.payerDfspId }}
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              class="header"
              *ngIf="datasource.transfer.payerDfspId !== undefined"
            >
              {{ "TRANSACTION_DETAILS.DFSP_NAME" | translate }}
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              *ngIf="datasource.transfer.payerDfspId !== undefined"
            >
              {{
                displayDfspName(getDfpsEntry(datasource.transfer.payerDfspId))
              }}
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              class="header"
              *ngIf="datasource.transfer.payerDateOfBirth !== undefined"
            >
              Date of Birth
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              *ngIf="datasource.transfer.payerDateOfBirth !== undefined"
            >
              {{ datasource.transfer.payerDateOfBirth }}
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              class="header"
              *ngIf="datasource.transfer.payerLastName !== undefined"
            >
              Last Name
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              *ngIf="datasource.transfer.payerLastName !== undefined"
            >
              {{ datasource.transfer.payerLastName }}
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              class="header"
              *ngIf="datasource.transfer.payerFirstName !== undefined"
            >
              First Name
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              *ngIf="datasource.transfer.payerFirstName !== undefined"
            >
              {{ datasource.transfer.payerFirstName }}
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </mat-grid-tile>
    <mat-grid-tile [colspan]="1" [rowspan]="1">
      <mat-card class="mat-elevation-z8" *ngIf="datasource.transfer">
        <mat-card-title>{{
          "TRANSACTION_DETAILS.PAYEE" | translate
        }}</mat-card-title>
        <mat-card-content>
          <div fxLayout="row wrap" class="content">
            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              class="header"
              *ngIf="datasource.transfer.payeePartyIdType !== undefined"
            >
              Id Type
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              *ngIf="datasource.transfer.payeePartyIdType !== undefined"
            >
              {{ datasource.transfer.payeePartyIdType }}
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              class="header"
              *ngIf="datasource.transfer.payeePartyId !== undefined"
            >
              Id
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              *ngIf="datasource.transfer.payeePartyId !== undefined"
            >
              {{ datasource.transfer.payeePartyId }}
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              class="header"
              *ngIf="datasource.transfer.payeeDfspId !== undefined"
            >
              DFSP Id
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              *ngIf="datasource.transfer.payeeDfspId !== undefined"
            >
              {{ datasource.transfer.payeeDfspId }}
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              class="header"
              *ngIf="datasource.transfer.payeeDfspId !== undefined"
            >
              DFSP Name
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              *ngIf="datasource.transfer.payeeDfspId !== undefined"
            >
              {{
                displayDfspName(getDfpsEntry(datasource.transfer.payeeDfspId))
              }}
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              class="header"
              *ngIf="datasource.transfer.payeeDateOfBirth !== undefined"
            >
              Date of Birth
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              *ngIf="datasource.transfer.payeeDateOfBirth !== undefined"
            >
              {{ datasource.transfer.payeeDateOfBirth }}
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              class="header"
              *ngIf="datasource.transfer.payeeLastName !== undefined"
            >
              Last Name
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              *ngIf="datasource.transfer.payeeLastName !== undefined"
            >
              {{ datasource.transfer.payeeLastName }}
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              class="header"
              *ngIf="datasource.transfer.payeeFirstName !== undefined"
            >
              First Name
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              *ngIf="datasource.transfer.payeeFirstName !== undefined"
            >
              {{ datasource.transfer.payeeFirstName }}
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </mat-grid-tile>
  </mat-grid-list>
  <mat-grid-list cols="2" rowHeight="450">
    <mat-grid-tile [colspan]="1" [rowspan]="1">
      <mat-card class="mat-elevation-z8" *ngIf="datasource.transfer">
        <mat-card-title>{{
          "TRANSACTION_DETAILS.TRANSFER" | translate
        }}</mat-card-title>
        <mat-card-content>
          <div fxLayout="row wrap" class="content">
            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              class="header"
              *ngIf="datasource.transfer.transactionId !== undefined"
            >
              Transfer Code
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              *ngIf="datasource.transfer.transactionId !== undefined"
            >
              {{ datasource.transfer.transactionId }}
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              class="header"
              *ngIf="datasource.transfer.amount !== undefined"
            >
              Transfer Amount
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              *ngIf="datasource.transfer.amount !== undefined"
            >
              {{ datasource.transfer.amount }}
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              class="header"
              *ngIf="datasource.transfer.currency !== undefined"
            >
              Transfer Currency
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              *ngIf="datasource.transfer.currency !== undefined"
            >
              {{ datasource.transfer.currency }}
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              class="header"
              *ngIf="datasource.transfer.feeType !== undefined"
            >
              Fee Type
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              *ngIf="datasource.transfer.feeType !== undefined"
            >
              {{ datasource.transfer.feeType }}
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              class="header"
              *ngIf="datasource.transfer.completedAt !== undefined"
            >
              Transfer Completed
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              *ngIf="datasource.transfer.completedAt !== undefined"
            >
              {{
                formatDate(
                  convertTimestampToUTCDate(datasource.transfer.completedAt)
                )
              }}
            </div>
            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              class="header"
              *ngIf="datasource.transfer.completedAt !== undefined"
            >
              Transfer Status
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              *ngIf="datasource.transfer.status !== undefined"
              [ngClass]="{
                red: datasource.transfer.status === 'FAILED',
                green: datasource.transfer.status === 'COMPLETED',
                orange: datasource.transfer.status === 'ACTION_NEEDED'
              }"
            >
              {{ datasource.transfer.status }}
              <div *ngIf="datasource.transfer.status === 'ACTION_NEEDED'">
                <button
                  mat-raised-button
                  color="primary"
                  (click)="
                    openRetryResolveDialog(
                      datasource.transfer.workflowInstanceKey,
                      'retry'
                    )
                  "
                >
                  <fa-icon icon="redo" size="sm"></fa-icon>&nbsp;RETRY</button
                >&nbsp;&nbsp;<button
                  mat-raised-button
                  color="primary"
                  (click)="
                    openRetryResolveDialog(
                      datasource.transfer.workflowInstanceKey,
                      'resolve'
                    )
                  "
                >
                  <fa-icon icon="check" size="sm"></fa-icon>&nbsp;RESOLVE
                </button>
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </mat-grid-tile>
    <mat-grid-tile [colspan]="1" [rowspan]="1">
      <mat-card class="mat-elevation-z8" *ngIf="datasource.transfer">
        <mat-card-title>{{
          "TRANSACTION_DETAILS.FEES" | translate
        }}</mat-card-title>
        <mat-card-content>
          <div fxLayout="row wrap" class="content">
            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              class="header"
              *ngIf="datasource.transfer.payerQuoteCode !== undefined"
            >
              Payer quote code
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              *ngIf="datasource.transfer.payerQuoteCode !== undefined"
            >
              {{ datasource.transfer.payerQuoteCode }}
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              class="header"
              *ngIf="datasource.transfer.payerFee !== undefined"
            >
              Payer fee
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              *ngIf="datasource.transfer.payerFee !== undefined"
            >
              {{ datasource.transfer.payerFee }}
              {{ datasource.transfer.payerFeeCurrency }}
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              class="header"
              *ngIf="datasource.transfer.payeeQuoteCode !== undefined"
            >
              Payee quote code
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              *ngIf="datasource.transfer.payeeQuoteCode !== undefined"
            >
              {{ datasource.transfer.payeeQuoteCode }}
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              class="header"
              *ngIf="datasource.transfer.payeeFee !== undefined"
            >
              Payee fee
            </div>

            <div
              fxFlex="50%"
              fxFlex.lt-md="50%"
              *ngIf="datasource.transfer.payeeFee !== undefined"
            >
              {{ datasource.transfer.payeeFee }}
              {{ datasource.transfer.payeeFeeCurrency }}
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </mat-grid-tile>
  </mat-grid-list>
</div>

<div class="mat-elevation-z8 container">
  <table mat-table [dataSource]="taskList" multiTemplateDataRows matSort>
    <ng-container matColumnDef="payment-task-list">
      <th mat-header-cell *matHeaderCellDef colspan="4">
        Transaction Task List
      </th>
    </ng-container>

    <ng-container matColumnDef="payment-process-id">
      <th mat-header-cell *matHeaderCellDef>Payment Process Id</th>
    </ng-container>

    <ng-container matColumnDef="payment-process-id-value">
      <th mat-header-cell *matHeaderCellDef colspan="3">
        {{ getPaymentProcessId() }}
      </th>
    </ng-container>

    <ng-container matColumnDef="timestamp">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Time (UTC)</th>
      <td mat-cell *matCellDef="let transaction">
        {{ formatDate(convertTimestampToUTCDate(transaction.timestamp)) }}
      </td>
    </ng-container>

    <ng-container matColumnDef="elementId">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Task Id</th>
      <td mat-cell *matCellDef="let transaction">
        {{ transaction.elementId }}
      </td>
    </ng-container>

    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Task Type</th>
      <td mat-cell *matCellDef="let transaction">{{ transaction.type }}</td>
    </ng-container>

    <ng-container matColumnDef="intent">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
      <td
        mat-cell
        *matCellDef="let transaction"
        [ngClass]="{
          orange: transaction.intent === 'CREATED',
          blue: transaction.intent === 'ACTIVATED',
          green: transaction.intent === 'COMPLETED'
        }"
      >
        {{ transaction.intent }}
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let transaction">
        <button mat-button color="grey">
          <span *ngIf="!checkExpanded(transaction)">
            <fa-icon icon="angle-down"></fa-icon>&nbsp;&nbsp;
          </span>
          <span *ngIf="checkExpanded(transaction)">
            <fa-icon icon="angle-up"></fa-icon>&nbsp;&nbsp;
          </span>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="expandedDetail">
      <td
        mat-cell
        *matCellDef="let transaction"
        [attr.colspan]="displayedColumns.length"
      >
        <div
          class="transaction-detail"
          [@detailExpand]="
            checkExpanded(transaction) ? 'expanded' : 'collapsed'
          "
        >
          <table mat-table [dataSource]="transaction.datasource" matSort>
            <ng-container matColumnDef="timestamp">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Time (UTC)
              </th>
              <td mat-cell *matCellDef="let transaction">
                {{
                  formatDate(convertTimestampToUTCDate(transaction.timestamp))
                }}
              </td>
            </ng-container>

            <ng-container matColumnDef="elementId">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Task Id</th>
              <td mat-cell *matCellDef="let transaction">
                {{ transaction.elementId }}
              </td>
            </ng-container>

            <ng-container matColumnDef="type">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Task Type
              </th>
              <td mat-cell *matCellDef="let transaction">
                {{ transaction.type }}
              </td>
            </ng-container>

            <ng-container matColumnDef="intent">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
              <td
                mat-cell
                *matCellDef="let transaction"
                [ngClass]="{
                  orange: transaction.intent === 'CREATED',
                  blue: transaction.intent === 'ACTIVATED',
                  green: transaction.intent === 'COMPLETED'
                }"
              >
                {{ transaction.intent }}
              </td>
            </ng-container>

            <tr
              mat-header-row
              *matHeaderRowDef="displayedColumnsDetailsTable"
            ></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: displayedColumnsDetailsTable"
            ></tr>
          </table>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="['payment-task-list']"></tr>
    <tr
      mat-header-row
      *matHeaderRowDef="['payment-process-id', 'payment-process-id-value']"
    ></tr>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      mat-row
      *matRowDef="let transaction; columns: displayedColumns"
      class="transaction-row"
      [class.transaction-expanded-row]="checkExpanded(transaction)"
      (click)="pushPopElement(transaction)"
    ></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: ['expandedDetail']"
      class="transaction-detail-row"
    ></tr>
  </table>
</div>

<div class="mat-elevation-z8 container marginTop100">
  <table mat-table [dataSource]="businessAttributes" matSort>
    <ng-container matColumnDef="payment-business-attributes">
      <th mat-header-cell *matHeaderCellDef colspan="3">
        Transaction Business Attributes
      </th>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
      <td mat-cell *matCellDef="let transaction">{{ transaction.name }}</td>
    </ng-container>

    <ng-container matColumnDef="timestamp">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Time (UTC)</th>
      <td mat-cell *matCellDef="let transaction">
        {{ formatDate(convertTimestampToUTCDate(transaction.timestamp)) }}
      </td>
    </ng-container>

    <ng-container matColumnDef="value">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Value</th>
      <td
        mat-cell
        *matCellDef="let transaction"
        [innerHTML]="transaction.value | prettyPrint"
      ></td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="['payment-business-attributes']"></tr>
    <tr
      mat-header-row
      *matHeaderRowDef="displayedBusinessAttributeColumns"
    ></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedBusinessAttributeColumns"
    ></tr>
  </table>
</div>
